const fabricSampleRow = ({ worksheet, row, fabricSample }) => {
	let col = 1;

	const createCell = (string) => {
		const cell = worksheet.cell(row, col++)
			.string(`${string}`)
			.style({
				fill: {
					type: 'pattern',
					patternType: 'solid',
					fgColor: '#f0f0f0',
				},
				border: {
					left: {
						style: 'thin',
						color: 'black'
					},
					right: {
						style: 'thin',
						color: 'black'
					},
					top: {
						style: 'thin',
						color: 'black'
					},
					bottom: {
						style: 'thin',
						color: 'black'
					},
					diagonal: {
						style: 'thin',
						color: 'black'
					},
					diagonalDown: true,
					outline: true
				}
			});
        
		return cell;
	};

	createCell(fabricSample.name);
	createCell(fabricSample.quantity);
};

const fabricSamplesHeaderRow = ({ workbook, worksheet, row }) => {
	const HEAD_ROW_STYLE = workbook.createStyle({
		alignment: {
			horizontal: 'center',
		},
		fill: {
			type: 'pattern',
			patternType: 'solid',
			fgColor: '#d5d5d5',
		},
		border: {
			left: {
				style: 'thin',
				color: 'black'
			},
			right: {
				style: 'thin',
				color: 'black'
			},
			top: {
				style: 'thin',
				color: 'black'
			},
			bottom: {
				style: 'thin',
				color: 'black'
			},
			diagonal: {
				style: 'thin',
				color: 'black'
			},
			diagonalDown: true,
			outline: true
		}
	});

	let col = 1;

	const cell = (string) => {
		worksheet.cell(row, col++)
			.string(string)
			.style(HEAD_ROW_STYLE);
	};

	cell("Fabric Name");
	cell("Qty");
};

const fabricSamplesSection = ({ workbook, worksheet, row, quoteData }) => {
	const HEADER_STYLE = workbook.createStyle({

		font: {
			size: 16,
			bold: true,
		}
	});

	let currentRow = row;

	worksheet
		.cell(currentRow++, 1)
		.string('Fabric Samples')
		.style(HEADER_STYLE);

	fabricSamplesHeaderRow({
		worksheet, workbook, row: currentRow++
	});

	quoteData.fabric_samples?.forEach((fabricSample) => fabricSampleRow({
		worksheet, row: currentRow++, fabricSample
	}));

	return currentRow;
};

export default fabricSamplesSection;
